var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.data,"backButtonRoute":'/settings/quality-control',"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig,"setLoading":_vm.setLoading,"validationSummary":_vm.validationSummary,"defaultPayload":_vm.updateDefaultPayload}})
}
var staticRenderFns = []

export { render, staticRenderFns }